export const heroCards = [
  {
    key: "tutor",
    name: "家教",
    desc: "上门一对一，家庭空间里的长期陪伴",
    icon: "ri-home-heart-line",
  },
  {
    key: "private",
    name: "私教",
    desc: "机构之外的私人定制，高强度目标导向",
    icon: "ri-user-star-line",
  },
  {
    key: "cram",
    name: "补习",
    desc: "小班与集体，比较、合作与隐藏的关照",
    icon: "ri-group-line",
  },
  {
    key: "coaching",
    name: "辅导",
    desc: "权威主导的纠错与重塑，依赖与对抗并存",
    icon: "ri-book-open-line",
  },
];

export const heroStats = [
  { value: "4", label: "核心关系场景", desc: "家教 · 私教 · 补习 · 辅导" },
  { value: "6", label: "角色原型", desc: "师生身份与立场划分" },
  { value: "12", label: "情境条目", desc: "按发生空间归类整理" },
  { value: "8", label: "章节脉络", desc: "从初识到关系重构" },
];

export const overviewParagraphs = [
  "秘密教学的核心并不在“教学”本身，而在教学关系里被不断放大的距离感：谁在教、谁在学、又是谁先越过那条看不见的线。",
  "本页把这类叙事拆成四个可对照的维度——家教、私教、补习与辅导，再向下展开为具体的角色类型、情境条目与互动细节。",
  "所有内容都按空间与关系整理，方便你从任意一个感兴趣的切面进入，再顺着章节清单理解关系是如何一步步变化的。",
];

export const overviewHighlights = [
  {
    title: "四种关系场景对照",
    desc: "把家教、私教、补习、辅导放进同一张表里横向比较，空间、关系与节奏的差异一眼可见。",
  },
  {
    title: "角色原型拆解",
    desc: "六种典型身份各自的立场、行为逻辑，以及他们在关系中承担的功能。",
  },
  {
    title: "十二个情境条目",
    desc: "按发生空间归类，每一条都给出具体场所、氛围基调与展开方式。",
  },
  {
    title: "八个章节脉络",
    desc: "从初次上门到新的学期，看清一段师生关系推进的完整节奏。",
  },
];

export const scenarios = [
  {
    key: "tutor",
    name: "家教",
    en: "Home Tutoring",
    icon: "ri-home-heart-line",
    setting: "上门一对一，学生家庭是主要舞台",
    space: "家庭空间（书房、客厅、餐桌）",
    relation: "长期陪伴型，信任在固定课时中缓慢累积",
    rhythm: "每周固定时段，节奏舒缓、日常",
    focus: "生活习惯与学习态度被同步改变",
    beats: [
      "初次上门时的试探与观察",
      "逐渐成形的上课仪式感",
      "课后自然延伸出的家庭互动",
      "家长临时缺席时的独处时刻",
    ],
    tags: ["一对一", "长期", "家庭空间"],
  },
  {
    key: "private",
    name: "私教",
    en: "Private Coaching",
    icon: "ri-user-star-line",
    setting: "机构之外的私人定制训练，强度偏高",
    space: "私域空间（工作室、训练房、出租屋）",
    relation: "目标导向型，专业与私人界限容易被模糊",
    rhythm: "短期集训为主，节奏紧张、密集",
    focus: "技能突破与心理压力的双重推进",
    beats: [
      "围绕单一目标制定的训练计划",
      "高强度练习中的情绪起伏",
      "阶段性成果的反复检验",
      "目标达成之后的关系转折",
    ],
    tags: ["定制", "高强度", "短期"],
  },
  {
    key: "cram",
    name: "补习",
    en: "Cram School",
    icon: "ri-group-line",
    setting: "小班或集体补习，个体与群像并行",
    space: "教学机构（教室、自习室）",
    relation: "同伴竞争与师生互动交织在一起",
    rhythm: "与学期同步，规律、可预期",
    focus: "集体中的比较、合作，以及藏起来的个别关照",
    beats: [
      "开学分班时的初次接触",
      "测验成绩带来的关系变化",
      "课后留堂时的单独交流",
      "集体活动中被暴露的关系",
    ],
    tags: ["小班", "群像", "竞争"],
  },
  {
    key: "coaching",
    name: "辅导",
    en: "Subject Guidance",
    icon: "ri-book-open-line",
    setting: "老师主导的课业纠正与习惯重塑",
    space: "教室与办公室",
    relation: "权威不对等型，纠正与依赖同时存在",
    rhythm: "随考试周期波动，张弛交替",
    focus: "错误被指出之后的心理变化与补偿",
    beats: [
      "批改作业时的逐条纠错",
      "单独约谈与适度规训",
      "进步被认可后的态度软化",
      "权威松动后的平等对话",
    ],
    tags: ["权威", "纠错", "周期性"],
  },
];

export const roles = [
  {
    name: "严谨家教老师",
    icon: "ri-book-2-line",
    stance: "引导者",
    traits: ["耐心", "边界感强", "观察细致"],
    desc: "通过固定的上门课时建立信任，习惯用提问代替直接给出答案，把耐心当成维持关系的方式。",
  },
  {
    name: "沉默型学生",
    icon: "ri-emotion-line",
    stance: "被观察者",
    traits: ["少言", "成绩中游", "抵触表达"],
    desc: "表面上配合所有安排，真正的态度变化藏在细节反应里，往往是场景张力的直接来源。",
  },
  {
    name: "严厉辅导老师",
    icon: "ri-shield-user-line",
    stance: "权威方",
    traits: ["高标准", "表达直接", "奖惩分明"],
    desc: "以纠错和规训推动进度，关系的转折通常出现在第一次真正认可之后。",
  },
  {
    name: "同班竞争者",
    icon: "ri-user-star-line",
    stance: "对照者",
    traits: ["好胜", "敏感", "信息灵通"],
    desc: "用成绩与关注度丈量彼此，让本属于两个人的互动被迫放进集体的比较坐标系里。",
  },
  {
    name: "家长与旁观者",
    icon: "ri-parent-line",
    stance: "缺席的在场者",
    traits: ["期待高", "时间少", "偶尔介入"],
    desc: "大部分时间不在现场，却决定了课堂之外的规则与边界，一旦介入就会改变原有节奏。",
  },
  {
    name: "私人教练",
    icon: "ri-user-settings-line",
    stance: "目标推动者",
    traits: ["专业", "强度高", "情绪直接"],
    desc: "在短期集训中同时承担教练、监督与情绪出口，专业与私人的界限因此变得模糊。",
  },
];

export const scenarioCategories = [
  "全部",
  "家庭空间",
  "教学机构",
  "私域空间",
  "户外场景",
  "公共场景",
];

export const scenarioTypes = [
  {
    title: "书房夜课",
    category: "家庭空间",
    place: "家中书房",
    tone: "安静、封闭",
    summary: "台灯下的长时间一对一，光线收束让注意力不得不集中在两个人之间。",
  },
  {
    title: "客厅餐桌辅导",
    category: "家庭空间",
    place: "客厅",
    tone: "日常、松弛",
    summary: "作业摊在餐桌上，家人走动与零碎对话构成持续的、不请自来的背景音。",
  },
  {
    title: "留堂后的空教室",
    category: "教学机构",
    place: "教室",
    tone: "克制的紧张",
    summary: "放学后只剩下两个人的空间，纠正与沉默在其中交替出现，谁先开口都很关键。",
  },
  {
    title: "自习室并排复习",
    category: "教学机构",
    place: "自习室",
    tone: "安静的陪伴",
    summary: "隔着一张桌子的固定距离，靠眼神、便条与递过来的笔记完成交流。",
  },
  {
    title: "办公室单独约谈",
    category: "教学机构",
    place: "办公室",
    tone: "严肃、正式",
    summary: "成绩单摊在桌面，谈话在权威与辩解之间来回，最终往往停在某个未说出口的让步上。",
  },
  {
    title: "私人工作室训练",
    category: "私域空间",
    place: "训练房",
    tone: "高强度、专注",
    summary: "围绕一个目标反复练习，汗水与情绪一起累积，直到有人先松口说今天到此为止。",
  },
  {
    title: "考前集训夜",
    category: "私域空间",
    place: "出租屋",
    tone: "封闭、密集",
    summary: "考试前的连续课时，作息与情绪被完全调成同一频率，边界在疲惫中一点点后退。",
  },
  {
    title: "琴房与画室",
    category: "私域空间",
    place: "专用教室",
    tone: "安静、艺术",
    summary: "以技能教学为外壳，实际考验的是耐心与信任，重复的练习里藏着关系的刻度。",
  },
  {
    title: "天台答疑",
    category: "户外场景",
    place: "学校天台",
    tone: "开阔、私密",
    summary: "离开教室之后的非正式交流，话题很容易越出课业，变成关于个体本身的对话。",
  },
  {
    title: "放学路上同行",
    category: "户外场景",
    place: "街道",
    tone: "生活化、短暂",
    summary: "从校门到路口的一小段路，反而成了当天唯一没有第三人在场的时段。",
  },
  {
    title: "图书馆相邻座位",
    category: "公共场景",
    place: "图书馆",
    tone: "疏离又靠近",
    summary: "公共空间里的低存在感交流，靠借阅记录与夹在书里的便条维系联系。",
  },
  {
    title: "家访往返",
    category: "公共场景",
    place: "居民区",
    tone: "过渡、含蓄",
    summary: "上门与离开的路上，关系在被反复掂量，决定往往发生在敲门前的那几秒。",
  },
];

export const interactions = [
  {
    title: "语言之外的暗示",
    icon: "ri-chat-3-line",
    desc: "停顿、语气与眼神往往承担了主要的信息量。把话直接说破会削弱张力，于是留白、答非所问和突然的沉默成了更常见的表达方式。",
  },
  {
    title: "距离与空间关系",
    icon: "ri-layout-grid-line",
    desc: "站位、座位与身体朝向的每一次细微调整，都在无声地标注双方关系的远近，比任何台词都更早地透露出态度变化。",
  },
  {
    title: "教学道具的转喻",
    icon: "ri-pen-nib-line",
    desc: "粉笔、试卷、教具原本只是工具，却常被用来承载情绪与权力的转移：递出、收回、压在桌面，每个动作都带着额外含义。",
  },
  {
    title: "时间与节奏控制",
    icon: "ri-time-line",
    desc: "课时的长短、沉默持续的秒数、打断的时机，共同构成了场景真正的心跳，也决定了紧张感是累积还是释放。",
  },
  {
    title: "身份差的张力",
    icon: "ri-scales-3-line",
    desc: "老师与学生、长辈与晚辈之间天然的不对等，是几乎所有冲突与和解的底色，也是关系能否向前推进的关键变量。",
  },
  {
    title: "冲突与和解",
    icon: "ri-emotion-sad-line",
    desc: "争执、误解与随之而来的退让，让关系在反复拉扯中缓慢向前，真正决定走向的往往不是谁对谁错，而是谁先示弱。",
  },
];

export const chapters = [
  { no: "01", title: "初次上门", theme: "建立关系", scene: "书房夜课", progress: "从陌生到初步信任" },
  { no: "02", title: "固定的课时", theme: "形成习惯", scene: "客厅餐桌辅导", progress: "从完成任务到愿意陪伴" },
  { no: "03", title: "一次不及格", theme: "权威受挫", scene: "办公室单独约谈", progress: "从对抗到彼此试探" },
  { no: "04", title: "留堂的下午", theme: "张力升级", scene: "留堂后的空教室", progress: "从沉默到主动开口" },
  { no: "05", title: "考前集训", theme: "距离拉近", scene: "考前集训夜", progress: "从并排到并肩" },
  { no: "06", title: "天台上的坦白", theme: "关系松动", scene: "天台答疑", progress: "从学生关系走向朋友" },
  { no: "07", title: "家长介入", theme: "外部压力", scene: "家访往返", progress: "从私域走向被审视" },
  { no: "08", title: "新的学期", theme: "关系重构", scene: "自习室并排复习", progress: "从依赖到各自独立" },
];

export const viewSteps = [
  {
    step: "01",
    title: "明确题材偏好",
    desc: "先判断自己更关注家庭空间里的长期陪伴，还是私域空间中短期高强度的叙事走向。",
  },
  {
    step: "02",
    title: "按场景筛选",
    desc: "使用下方的场景筛选，快速定位到家中、教室、私域、户外或公共几类具体情境。",
  },
  {
    step: "03",
    title: "对照关系进展",
    desc: "结合章节清单查看每一节所处的关系阶段，理解互动细节背后的来龙去脉。",
  },
  {
    step: "04",
    title: "找到观看入口",
    desc: "按题材、场景与章节三条线索，选择与自己关注点最接近的观看入口继续深入。",
  },
];

export const faqs = [
  {
    q: "本站主要讲什么？",
    a: "本页围绕秘密教学中的师生家教题材，系统梳理家教、私教、补习、辅导四种关系场景，并向下展开对应的角色类型、情境条目与互动细节。",
  },
  {
    q: "家教、私教、补习和辅导有什么区别？",
    a: "区别主要在空间、关系结构与节奏上：家教偏向家庭空间的长期陪伴，私教偏向目标导向的短期高强度，补习强调集体与比较，辅导则突出权威不对等下的纠错与依赖。",
  },
  {
    q: "页面内容需要登录才能查看吗？",
    a: "不需要。全部内容在页面中直接呈现，所有筛选与展开操作都只作用于本站已有的内容，不涉及账号或任何提交。",
  },
  {
    q: "场景清单按什么标准分类？",
    a: "按发生空间与关系氛围划分为家庭空间、教学机构、私域空间、户外场景与公共场景五类，方便按同一脉络横向对照。",
  },
  {
    q: "怎样快速定位感兴趣的内容？",
    a: "先看四种关系场景对比确定大致方向，再用场景筛选把范围缩小，最后结合章节清单查看具体的关系进展。",
  },
  {
    q: "内容会持续更新吗？",
    a: "场景条目与章节清单会随题材整理持续推进，页面当前展示的信息即为最新整理结果，后续同类切面会继续补充。",
  },
];